import PortalIdParser from 'PortalIdParser';
import CrossTabConfig from 'worker-connection-library/calling-cross-tab-utils/CrossTabConfig';
import { _CrossTabManager } from './CrossTabManager';
import { createChannelBroadcastMessage } from '../messages/createBroadcastMessages';
import { HEARTBEAT_REQUEST } from '../types/BroadcastEvents';
export const CALLING_EXTENSIONS_REMOTE_CROSS_TAB = 'calling-extensions-remote-cross-tab';
export class _CrossTabConnectionManager extends _CrossTabManager {
  // Even though the heartbeat is running every second, the difference between
  // `now()` and the heartbeat timestamp is sometimes coming back as over 2 seconds,
  // causing the the tab to be removed and a new master chosen. Extending the
  // threshold to 3 seconds

  constructor() {
    super();
    this.heartbeat = () => {
      if (!this.broadcastChannel) {
        return;
      }
      const requestMessage = createChannelBroadcastMessage({
        type: HEARTBEAT_REQUEST,
        payload: {},
        messageRelayChannel: this.broadcastChannel.name,
        originConnectionId: this.getConnectionId()
      });
      this.broadcastChannel.postMessage(requestMessage);
    };
    this.onmessage = event => {
      const message = event.data;
      const type = message && message.type;
      if (type === HEARTBEAT_REQUEST && this.getConnectionId() !== message.originConnectionId) {
        this.setTabListData();
      }
    };
    this.closeChannel = () => {
      if (!this.broadcastChannel) {
        return;
      }
      this.broadcastChannel.removeEventListener('message', this.onmessage);
      this.broadcastChannel.close();
    };
    this.stop = () => {
      this.stopTabManagement();
      this.stopCrossTabHeartbeat();
      this.stopCleanupTimer();
      this.closeChannel();
    };
    this.connectionId = CrossTabConfig.get().connectionId;
    this.storageTabLastUpdatedKey = `Tab_Master-${PortalIdParser.get()}`;
    if ('BroadcastChannel' in window) {
      this.broadcastChannel = new BroadcastChannel(CALLING_EXTENSIONS_REMOTE_CROSS_TAB);
    }
  }
  start() {
    this.startTabManagement();
    this.startCrossTabHeartbeat();
    this.startCleanupTimer(this.heartbeat);
    if (this.broadcastChannel) {
      this.broadcastChannel.addEventListener('message', this.onmessage);
    }
  }
}
export const crossTabConnectionManager = new _CrossTabConnectionManager();